import React from 'react';
import { InputProps } from '../../types';

const Input: React.FC<InputProps> = ({
  label,
  error,
  required = false,
  disabled = false,
  placeholder,
  type = 'text',
  value,
  onChange,
  className = '',
  id,
  name,
  autoComplete,
}) => {
  const inputClasses = `form-input ${error ? 'form-input-error' : ''} ${className}`;

  return (
    <div className="w-full">
      {label && (
        <label className="form-label">
          {label}
          {required && <span className="text-danger-500 ml-1">*</span>}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        className={inputClasses}
        id={id}
        name={name}
        autoComplete={autoComplete}
      />
      {error && (
        <p className="form-error">{error}</p>
      )}
    </div>
  );
};

export default Input;
